import React, { useCallback } from "react";
import { log } from "@qgiv/core-js";
import { useDispatch } from "react-redux";
import { ModalContentReplacerEnums } from "../../common/ModalContentReplacer";
import { usePaymentPageData } from "../../PageDataHooks";
import {
    getInitialTouched,
    getInitialValues,
    getValidationSchema,
} from "./formik";
import { setShouldScrollToTop } from "../../../redux/slices/appSettingsSlice";
import { updateSubmitDonation } from "../../../redux/slices/donationDetailsSlice";
import ConnectedRecurringUpgrade from "./RecurringUpgrade";
import PaymentPage from "./PaymentPage";
import ConnectedExitIntent from "../../common/ExitIntent";

const ConnectedPaymentPage = () => {
    // -------------------------------------------------------------------------
    // NOTE: Single Step form uses a different component set than these Connected Pages.
    // It does share the custom getPageData hooks, but if you make changes in the Connected Pages
    // make sure to make the same changes in the ConnectedSinglePage.js file.
    // -------------------------------------------------------------------------
    const dispatch = useDispatch();
    const paymentPageData = usePaymentPageData();
    const {
        acceptedEmailReminders,
        documentTitle,
        enableAbandonedGifts,
        enableReminderEmails,
        formikSettings,
        getShouldSubmitDonation,
        selectedContentToDisplay,
        shouldDisplayRecurringUpgrade,
        submitDonation,
    } = paymentPageData;

    const getAlternateContent = useCallback(() => {
        const alternateContent = [];
        if (shouldDisplayRecurringUpgrade) {
            alternateContent.push({
                component: <ConnectedRecurringUpgrade />,
                type: ModalContentReplacerEnums.UPGRADE_RECURRING_UI,
            });
        }
        if (enableAbandonedGifts && enableReminderEmails) {
            alternateContent.push({
                component: <ConnectedExitIntent />,
                type: ModalContentReplacerEnums.EXIT_INTENT_UI,
            });
        }
        return alternateContent;
    }, [
        enableAbandonedGifts,
        enableReminderEmails,
        shouldDisplayRecurringUpgrade,
    ]);

    const alternateContent = getAlternateContent();

    // Verify that the conditions are right before proceeding to submission
    const onSubmit = (values, formikBag) => {
        getShouldSubmitDonation(values, formikBag)
            .then(({ shouldSubmitDonation }) => {
                if (shouldSubmitDonation) {
                    dispatch(setShouldScrollToTop(true));
                    dispatch(updateSubmitDonation(true));
                }
            })
            .catch((errors) => {
                log(errors);
            });
    };

    const {
        initialTouchedSettings,
        initialValuesSettings,
        validationSettings,
    } = formikSettings;

    const formikProps = {
        initialTouched: getInitialTouched(initialTouchedSettings),
        initialValues: getInitialValues(initialValuesSettings),
        validationSchema: getValidationSchema(validationSettings),
        onSubmit,
    };

    const paymentPageProps = {
        acceptedEmailReminders,
        alternateContent,
        documentTitle,
        formikProps,
        selectedContentToDisplay,
        submitDonation,
    };
    return <PaymentPage {...paymentPageProps} />;
};

export default ConnectedPaymentPage;
